module.exports = __webpack_public_path__ + "static/media/error.cf7a9aa1.svg";